import React, { PropsWithChildren } from 'react';
import { Progress } from '@backstage/core-components';
import { Navigate, useLocation } from 'react-router-dom';
import { useServiceRegistryLanguage } from './ServiceRegistryLanguageProvider';

export const ProfileCompletionGuard = ({ children }: PropsWithChildren<{}>) => {
  const location = useLocation();
  const { loading, profileComplete } = useServiceRegistryLanguage();
  const settingsRoute = location.pathname.startsWith('/settings');

  if (loading) return <Progress />;
  if (!profileComplete && !settingsRoute) {
    return (
      <Navigate
        to="/settings/general"
        replace
        state={{ returnTo: `${location.pathname}${location.search}` }}
      />
    );
  }
  return <>{children}</>;
};
